import { useQuery } from '@tanstack/react-query'
import { getInterlaceWidgetToken } from '../walletServices'
import { GetInterlaceWidgetTokenParams } from '../walletTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

export const useGetInterlaceWidgetToken = (
  params: GetInterlaceWidgetTokenParams,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.INTERLACE_WIDGET_TOKEN, params],
    queryFn: () => getInterlaceWidgetToken(params),
    staleTime: 5 * 60 * 1000,
    enabled: !!params.card_id,
  })
